<template>
  <table v-if="costs" class="sf-table tw-text-left">
    <tbody>
      <tr v-for="p in productsAvailable" :key="p.name">
        <td>
          <input type="checkbox" v-model="products" :value="p.kind" :id="'pcb-' + p.name" />
        </td>
        <td>
          <label class="first-letter:tw-uppercase" :for="'pcb-' + p.name">
            {{ p.label }}
          </label>
        </td>
        <td>
          {{ $filters.longDateFormat(p.period?.start, false) }} -
          {{ $filters.longDateFormat(p.period?.end, false) }}
        </td>
        <td class="tw-text-right">
          {{ $filters.renderMoney(p.cost) }}
        </td>
      </tr>
      <tr>
        <td></td>
        <td></td>
        <td class="tw-text-right">{{ costs.comboDiscount.label }}</td>
        <td class="tw-text-right">
          -{{ $filters.renderMoney(discount) }}
        </td>
      </tr>
      <tr class="tw-font-bold">
        <td></td>
        <td></td>
        <td class="tw-text-right">Total</td>
        <td class="tw-text-right">
          {{ $filters.renderMoney(total) }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script lang="ts">
import apiCall from "@/func/net/apiCall";
import {
  SfStoreSubscriptionsCost,
  SfSubscriptionKind,
} from "@/types/generalTypes";
import { defineComponent, PropType } from "vue";

export default defineComponent({
  props: {
    modelValue: {
      type: Object as PropType<SfSubscriptionKind[]>,
      required: true,
    },
  },
  data() {
    return {
      costs: null as SfStoreSubscriptionsCost | null,
      products: [] as SfSubscriptionKind[],
      productAvailableCount: 0,
    };
  },
  computed: {
    discount() {
      if (!this.costs) {
        return 0;
      }
      return this.products.length >= this.productAvailableCount  
        ? this.costs.comboDiscount.discount  
        : 0;
    },
    total() {
      if (!this.costs) {
        return 0;
      }
      let total = 0;
      for (const p of this.products) {
        total += this.costs.subscriptions[p].cost;
      }
      return total - this.discount;
    },
    productsAvailable() {
      if (!this.costs) {
        return [];
      }
      return this.costs.subscriptions;
    },
  },
  mounted() {
    this.refreshCosts();
    this.products = this.modelValue;
  },
  methods: {
    async refreshCosts() {
      const resData = await apiCall("account/individual-cost");
      if (resData.success) {
        this.costs = { ... resData.data as SfStoreSubscriptionsCost, subscriptions: {} };
        this.productAvailableCount = 0;
        this.products = [];
        for(let i in resData.data.subscriptions) {
          if(resData.data.subscriptions[i]) {
            this.costs.subscriptions[i] = resData.data.subscriptions[i];
            this.productAvailableCount++;
            this.products.push(i as SfSubscriptionKind);
          }
        }
      }
    },
  },
  watch: {
    products() {
      this.$emit("update:modelValue", this.products);
    },
  },
});
</script>
